import type { ComponentProps, ReactNode } from "react";
import { useNavigate } from "react-router";
import { Button } from "@/components/ui/button";
import { useAuthUser } from "@/context/auth/AuthContext";

/**
 * El camino a los planes, que es sólo del dueño (trd-client#269, AC-7a).
 *
 * Mi Suscripción es del dueño: un empleado que tocaba "Ver planes" terminaba en
 * "No autorizado". Por eso este botón no se dibuja para nadie más, y quien lo
 * use no tiene que acordarse de preguntar el rol.
 */
export default function VerPlanes({
  children = "Ver planes",
  ...props
}: Omit<ComponentProps<typeof Button>, "onClick" | "children"> & {
  children?: ReactNode;
}) {
  const usuario = useAuthUser();
  const navigate = useNavigate();
  if (usuario?.type !== "owner") return null;
  return (
    <Button {...props} onClick={() => navigate("/mi-suscripcion")}>
      {children}
    </Button>
  );
}
